export { getFilterSlugForPage } from '../utils';

export const parseMonetaryValue = (text: string | undefined): number => {
  if (!text) return 0;
  const match = text.match(/\$([\d,]+(?:\.\d+)?)/);
  if (!match) return 0;
  return parseFloat(match[1].replace(/,/g, '')) || 0;
};

export const parsePercentageValue = (text: string | undefined): number => {
  if (!text) return 0;
  // Match all patterns like "4.15%", "Up to 4.15%", "4.00% for 6mo"
  const matches = text.matchAll(/([\d.]+)%/g);
  const percentages = Array.from(matches).map(match => parseFloat(match[1]));
  if (percentages.length === 0) return 0;
  // Return the highest percentage found
  return Math.max(...percentages);
};

export const getStringValueForDriver = (value: string | number | null | undefined) => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return String(value || '');
};
